import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';
import SortableMealOptionField from './SortableMealOptionField';


const MealOptionFields = ({ fields, id, label, hideFormGroup, mealOptionCounts, onDeleteMealOption, meta: { touched, error } }) => (
  <div className={`${hideFormGroup ? '' : 'form-group'} ${touched && error ? 'has-error' : ''}`} style={{ position: 'relative' }}>
    <label htmlFor={id}>{label}</label>
    <div id={id} className="meal-option-list sortable-list">
      {fields.map((mealOption, index, fieldsRef) => (
        <SortableMealOptionField
          key={index}
          mealOption={mealOption}
          index={index}
          fieldIndex={index}
          fields={fieldsRef}
          mealOptionCounts={mealOptionCounts}
          onDeleteMealOption={onDeleteMealOption}
        />
      ))}
    </div>
    <span role="button" className="text-primary add-meal-option" onClick={() => fields.push({ name: '', editing: true })}>+ Add a Meal Option</span>
  </div>
);

MealOptionFields.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  hideFormGroup: PropTypes.bool,
  mealOptionCounts: PropTypes.shape({}),
  onDeleteMealOption: PropTypes.func,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
};

const SortableMealOptions = SortableContainer(props => <MealOptionFields {...props} />);


export default SortableMealOptions;



/** WEBPACK FOOTER **
 ** ./src/components/manage/common/EventForm/SortableMealOptions/SortableMealOptions.jsx
 **/